import { Permission, PermissionJson } from './permission'

declare const RoleIDSymbol: unique symbol
export type RoleID = string & { [RoleIDSymbol]: never }

export interface RoleJson {
    id: string
    name: string
    permissions?: { data: PermissionJson[] }
}

export class Role {
    id: RoleID
    name: string

    permissions: Permission[] = []

    constructor(
        id: string,
        name: string,
        permissions: Permission[] = [],
    ) {
        this.id = id as RoleID
        this.name = name
        this.permissions = permissions
    }

    static fromJson(json: RoleJson): Role {
        return new Role(
            json.id,
            json.name,
            json.permissions?.data ? json.permissions.data.map((permission: PermissionJson) => Permission.fromJson(permission)) : [],
        )
    }
}